/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanResponse } from '../../models/boolean-response';

export interface DeleteProfileSubscription$Params {
  id: number;
  profileSubscriptionId: number;
}

export function deleteProfileSubscription(http: HttpClient, rootUrl: string, params: DeleteProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteProfileSubscription.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('profileSubscriptionId', params.profileSubscriptionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanResponse>;
    })
  );
}

deleteProfileSubscription.PATH = '/rest/admin/profile/{id}/subscription/{profileSubscriptionId}';
